/** Date formatting shared across the Patient Records module. */

const format = (value, options) => {
  if (!value) return "—";
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return "—";
  return d.toLocaleDateString("en-GB", options);
};

/** "12 Jul 26" — compact enough to sit in a table column. */
export const formatShortDate = (value) =>
  format(value, { day: "2-digit", month: "short", year: "2-digit" });

/** "12 Jul 2026" — for list rows that have room to breathe. */
export const formatLongDate = (value) =>
  format(value, { day: "2-digit", month: "short", year: "numeric" });
